import { createSlice } from '@reduxjs/toolkit';
import { findPropertySubCategory, createPropertySubCategory, getPropertySubCategory } from './api';
import { initialState } from './api/interface';

const propertySubCategorySlice = createSlice({
  name: 'propertySubCategory',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findPropertySubCategory.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findPropertySubCategory.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findPropertySubCategory.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(createPropertySubCategory.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createPropertySubCategory.fulfilled, (state, action) => {
      state.data.push(action.payload);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(createPropertySubCategory.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
    builder.addCase(getPropertySubCategory.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getPropertySubCategory.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getPropertySubCategory.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = propertySubCategorySlice.actions;
export default propertySubCategorySlice.reducer;
